import { type ApiClient } from "@anna-money/anna-web-lib/api";
import {
  type SoleTraderQuestionnaireConfig,
  SoleTraderQuestionnaireResponseData,
} from "./soleTraderQuestionnaireTypes";

export class SoleTraderQuestionnaireClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async getFlowConfig(): Promise<SoleTraderQuestionnaireConfig> {
    const response = await this._apiClient.get("api/formations/sole-trader-questionnaire");
    const data = response.getData(SoleTraderQuestionnaireResponseData);
    return {
      firstQuestionId: data.firstQuestionId,
      questions: data.questions,
    };
  }
}
